import React from 'react'
import styled from 'styled-components'
import { media } from 'styles/media'
import { square } from 'styles/global'
import * as spacing from 'styles/spacing'
import Icon from 'components/Icon'

const Container = styled.div`
  text-align: center;

  width: 100%;
  ${media.medium`width: 835px;`};
`

const PerksList = styled.div`
  display: flex;
  gap: ${spacing.small};
  flex-direction: column;
  margin: ${spacing.large} 0;

  ${media.small`
    margin: ${spacing.xxLarge} 0;
    flex-direction: row;
  `}

  ${media.medium`
    gap: ${spacing.large};
  `}
`

const Perk = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  text-align: left;

  gap: ${spacing.small};
  ${media.medium`gap: ${spacing.large}`};
`

const PerkIcon = styled(Icon)`
  flex-shrink: 0;

  ${square`46px`};
  ${media.medium`${square`60px`}`};
`

const VuseRewardsPerks = () => (
  <Container>
    <p>Join MYVUSE Rewards and opt-in to Vuse Marketing communications to get your offer from our Brand Ambassador.</p>

    <PerksList>
      <Perk>
        <PerkIcon icon="vuse-rewards/welcome" />
        <p>
          <strong>Collect up to 1,400 points</strong> when you join MYVUSE Rewards*
        </p>
      </Perk>

      <Perk>
        <PerkIcon icon="vuse-rewards/multiplier_1.2" />
        <p>
          <strong>Progress your tier </strong> to unlock up to 1.2X** the points on eligible Vuse product***
        </p>
      </Perk>

      <Perk>
        <PerkIcon icon="vuse-rewards/giftCard" />
        <p>
          <strong>Redeem your points</strong> for Vuse coupons or other rewards.
        </p>
      </Perk>
    </PerksList>
  </Container>
)

export default VuseRewardsPerks
